import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/firm",
  component: RouteComponent,
  meta: { requiresAuth: true },
  children: [
    {
      path: "enterprises",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "firm.enterprises.index",
          component: () =>
            import(
              /* webpackChunkName: "firm-enterprises" */ "@/views/accountant/AccountantEnterprisesView.vue"
            ),
          meta: {
            title: "enterprises-list",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
        {
          path: "create",
          name: "firm.enterprises.create",
          component: () =>
            import(
              /* webpackChunkName: "firm-enterprises-create" */ "@/views/enterprises/EnterpriseCreate.vue"
            ),
          meta: {
            title: "enterprise-create",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
            requiredRole: 2,
          },
        },
      ],
    },
    {
      path: "users",
      name: "firm.users",
      component: () =>
        import(
          /* webpackChunkName: "firm-users" */ "@/views/accountant/AccountantUsersView.vue"
        ),
      props: true,
      meta: {
        title: "users-list",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
        requiredRole: 2,
      },
    },
    {
      path: "customization",
      name: "firm.customization",
      component: () =>
        import(
          /* webpackChunkName: "firm-customization" */ "@/views/accountant/AccountantCustomizationView.vue"
        ),
      props: true,
      meta: {
        title: "customization",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
        requiredRole: 2,
      },
    },
  ],
};
